import { CheckoutOptionsType, PaymentStatus } from "@is/constants";
import { TrackingEventTypes } from "@is/services/EventTracking";
import { BasketItem } from "@is/types/basket";

export type FieldState = {
  value: string;
  isRequired: boolean;
  isDisabled?: boolean;
  validationRegex?: RegExp;
  maxLength?: number;
  isEnabled?: boolean;
  id?: string;
  label?: string;
  name?: string;
  type?: string;
  parentType?: CheckoutOptionsType;
  subtype?: string;
};

export type ReducedFieldState = Pick<FieldState, "id" | "value" | "name">;

export type CheckoutFormState = {
  firstName?: FieldState;
  lastName?: FieldState;
  phoneNumber?: FieldState;
  email?: FieldState;
  address?: FieldState;
  address2?: FieldState;
  houseNumber?: FieldState;
  zipCode?: FieldState;
  city?: FieldState;
  stateRegion?: FieldState;
  country?: FieldState;
  phoneOrEmail?: FieldState;
};

export type OrderProperty = {
  id: string;
  value: string;
};

export type CheckoutAgreementOrderType = {
  title: string;
  isRequired: boolean;
  isChecked: boolean;
};

export type Order = {
  checkoutConfigurationId: string;
  properties: OrderProperty[];
  validateCountryWithZipCode: boolean;
  checkoutAgreements: CheckoutAgreementOrderType[];
};

export type ValidateOrder = {
  id: string;
  properties: OrderProperty[];
  validateCountryWithZipCode: boolean;
};

export type FieldsValidation = {
  [key: string]: { error: boolean; message: string };
};

export enum InputTypes {
  Text = "text",
  Password = "password",
  Email = "email",
  Tel = "tel",
  Search = "search",
  Url = "url",
}

export enum CheckoutInputFields {
  FirstName = "firstName",
  LastName = "lastName",
  PhoneNumber = "phoneNumber",
  Email = "email",
  Address = "address1",
  Address2 = "address2",
  HouseNumber = "houseNumber",
  ZipCode = "zipCode",
  City = "city",
  StateRegion = "stateRegion",
  Country = "country",
  PhoneNumberOrEmail = "phoneNumberOrEmail",
}

export type CheckoutPropertyField = {
  name: string;
  label: string;
  isRequired?: boolean;
  configValueRequired?: boolean;
  description?: string;
  isEnabled?: boolean;
  maxLength?: number;
  value?: string;
  id?: string;
};

export type SectionDetails = {
  label: string;
  isEnabled: boolean;
  description?: string;
  properties: CheckoutPropertyField[];
  name: string;
};

export type CheckoutSection = {
  [key: string]: SectionDetails;
};

export type CheckoutConfiguration = {
  id?: string;
  type: string;
  label: string;
  isEnabled: boolean;
  deliveryOptions?: CheckoutSection;
  recipientOptions?: CheckoutSection;
  checkoutEndpointOptions?: CheckoutSection;
};

export type CheckoutAttempt = {
  externalId: string;
  createdAt: string;
  status: PaymentStatus;
  result: {
    message: string;
    statusCode: number;
    redirectUri?: string;
  };
  payload: string;
};

export type CheckoutDetails = {
  id: string;
  sessionId: string;
  storeId: string;
  deviceId: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  deliveryAddress: {
    addressLine1: string;
    addressLine2: string;
    houseNumber: string;
    zipCode: string;
    city: string;
    region: string;
    country: string;
  };
  checkoutAttempts: CheckoutAttempt[];
  basketItems: BasketItem[];
  languageCode?: string;
};

export type SelectionColorVariantInfo = {
  [key: string]: TrackingEventTypes;
};
